<form class="form-container" [formGroup]="serverForm" (ngSubmit)="onSubmit()">
  <div class="text">
    <p>{{ 'SERVER_FORMS_INFO_TEXT' | translate }}</p>
  </div>

  <mat-form-field>
    <mat-label>{{ 'Version' | translate }}</mat-label>
    <mat-select id="osVersion" formControlName="osVersion">
      @for (version of versions; track version) {
        <mat-option [value]="version.value">{{ version.label }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'Primary Owner' | translate }}</mat-label>
    <input
      matInput
      id="primaryOwner"
      type="text"
      formControlName="primaryOwner"
    />
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'Department' | translate }}</mat-label>
    <input matInput id="department" type="text" formControlName="department" />
  </mat-form-field>

  <div class="inline-info">
    <mat-form-field class="inline-form">
      <mat-label>{{ 'Enddate' | translate }}</mat-label>
      <input matInput id="endDate" type="text" formControlName="endDate" />
    </mat-form-field>
    <i
      ><img
        class="infobutton"
        src="../../../assets/icons/Information-Circle--Streamline-Ultimate.svg"
        alt="Info"
        [matTooltip]="'ENDDATE_SERVER_INFO' | translate"
        matTooltipClass="newline-matTooltip"
    /></i>
  </div>
  <div class="inline-info">
    <mat-form-field class="inline-form">
      <mat-label>{{ 'Description' | translate }}</mat-label>
      <textarea
        matInput
        id="function"
        type="text"
        formControlName="function"
      ></textarea>
    </mat-form-field>
    <i
      ><img
        class="infobutton"
        src="../../../assets/icons/Information-Circle--Streamline-Ultimate.svg"
        alt="Info"
        [matTooltip]="'DESCRIPTION_SERVER_INFO' | translate"
        matTooltipClass="newline-matTooltip"
    /></i>
  </div>

  <hr />
  <div class="form-footer">
    <div class="form-nav"></div>
    <div class="submit">
      <button mat-flat-button color="primary" [disabled]="!serverForm.valid">
        {{ 'Send' | translate }}
      </button>
    </div>
  </div>
</form>
